<template>
  <!-- 績效優化建議的指標項目（我的優勢／值得關注），績效頁與儀錶板共用 -->
  <div class="metric-item">
    <div class="flex items-center justify-between" style="gap: 8px">
      <p class="metric-name">{{ item.dimension }}｜{{ item.name }}</p>
      <p v-if="item.value" class="metric-value">{{ item.value }}</p>
    </div>
    <p class="metric-text">{{ item.text }}</p>
    <div v-if="differences.length" class="flex flex-wrap" style="gap: 8px">
      <Tag v-for="diff in differences" :key="diff" :type="tagType" size="small">
        {{ diff }}
      </Tag>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import Tag from '@/components/Tag/Tag.vue'

export default defineComponent({
  name: 'AdviceMetricItem',
  components: { Tag },
  props: {
    item: { type: Object, required: true },
    tagType: { type: String, default: 'success' },
  },
  setup (props) {
    // 差異數據：與店內中位數、同業 PR、個人趨勢；沒有的比較為 null
    const differences = computed(() => [props.item.vsShop, props.item.peerPR, props.item.trend].filter(Boolean))
    return { differences }
  },
})
</script>

<style lang="postcss" scoped>
.metric-item {
  @apply flex flex-col gap-[8px] border border-gray-40 rounded-[8px] p-[16px];
}
.metric-name {
  @apply font-medium text-gray-100;
}
.metric-value {
  @apply text-primary-100 font-bold flex-shrink-0;
}
.metric-text {
  @apply text-gray-80 leading-[22px];
}
</style>
